<template>
    <div class="component-wrap">
        <Header-menu :menuVisible="false" />
        <main class="page centered">
            <h1 class="form__title">{{ $t("Восстановление пароля") }}</h1>
            <form class="form">
                <div class="form__row">
                    <baseInput
                        v-model="model_email_recover"
                        type="text" placeholder="E-mail" :class="{'form-group--error': model_email_recover && !valid}"
                        :error="model_email_recover!='' && !valid"
                        :message="message"
                        :v="$v.email"
                        @focus="valid = true"
                    />
                </div>
                <button-red type="button" class=" btn--big" @click.native="post_email()">{{ $t("Получить пароль на почту") }}</button-red>
                <v-layout class="form__row justify-center">
                    <greenLink @click.native="go_to_auth">{{ $t("Авторизация") }}</greenLink>
                </v-layout>
                <ModalRecover ref="modal" />
            </form>
        </main>
    </div>
</template>

<script>
import {required, email} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import ModalRecover from './recover_modal';
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import baseInput from '@/components/ui/inputs/base/input.vue';
import ButtonRed from '@/components/ui/buttons/button_red.vue';
import greenLink from '@/components/ui/links/styled/link_green.vue';
import {mapMutations, mapActions, mapGetters} from 'vuex';
import {post} from 'axios';
import api from '@/api/index';
import router from '@/router';

export default {
  name      : 'PwdRecover',
  components: {
    HeaderMenu,
    baseInput,
    ButtonRed,
    greenLink,
    ModalRecover,
  },
  mixins     : [validationMixin],
  validations: {
    email: {
      required,
      email,
    },
  },
  props: {
    menuVisible: {
      type: Boolean,
    },
  },
  data() {
    return {
      valid  : true,
      message: '',
    };
  },

  computed: {
    ...mapGetters('autorisation', ['email_recover']),
    model_email_recover: {
      get() {
        return this.email_recover;
      },
      set(event) {
        this.SET_EMAIL_RECOVER(event.target.value);
      },
    },
  },
  methods: {
    ...mapMutations('autorisation', ['SET_EMAIL_RECOVER', 'SET_MODAL_RECOVER']),
    async post_email() {
      if (!this.email_recover) {
        this.valid = false;
      } else {
        try {
          let {data: {status, message}} = await api.user.forgot_pass(this.email_recover);

          if (status == 'OK') {
            this.valid = true;
            this.$router.push({name: 'recover_true'});
          } else if (status == 'ERROR') {
          	this.valid = false;
          	this.message = message;
          }
        } catch (err) {
	        this.valid = false;
        }
      }
    },
    go_to_auth() {
      window.history.replaceState(0, '/pwd_recover', '/');
      this.$router.push({name: 'auth'});
    },
  },
};

</script>
